"use strict";

import $ from "jquery";
import url from "url";

const getHash = function () {
  const hash = url.parse(window.location.toString()).hash;
  return hash ? hash.substring(1) : undefined;
};

const escapeHash = function (hash) {
  return hash.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&");
};

const findHashElement = function (hash) {
  let elem;
  if (hash) {
    const escapedHash = escapeHash(hash);
    elem = $(`#${escapedHash}`)[0];
    if (!elem) {
      elem = $(`a[name="${escapedHash}"]`)[0];
    }
  }
  return elem; // Might be undefined
};

const scrollToRelativeAnchor = function () {
  const elem = findHashElement(getHash());
  if (elem) {
    // Push this onto the end of the stack
    window.setTimeout(() => elem.scrollIntoView(), 0);
  }
};

$(document).on("turbolinks:load", function () {
  scrollToRelativeAnchor();
});
